import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

export default function HistoryPage() {
  const [txns, setTxns] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/transactions"); setTxns(data); })(); }, []);

  const colorFor = (chg) => chg > 0 ? "text-success" : "text-accent";

  const dl = async (path, filename) => {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a"); a.href = url; a.download = filename; a.click();
  };

  return (
    <div className="space-y-8" data-testid="history-page">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div><div className="overline">Activity</div><h1 className="font-display text-4xl sm:text-5xl mt-2">Inventory history</h1></div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => dl("/reports/transactions", "history.csv")} data-testid="history-export-csv">
            <Download className="w-4 h-4 mr-2" strokeWidth={1.5}/> CSV
          </Button>
          <Button variant="outline" onClick={() => dl("/reports/transactions.pdf", "history.pdf")} data-testid="history-export-pdf">
            <Download className="w-4 h-4 mr-2" strokeWidth={1.5}/> PDF
          </Button>
        </div>
      </div>
      <div className="grid-border-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary/60 text-xs uppercase tracking-widest text-muted-foreground">
              <tr><th className="text-left px-4 py-3">When</th><th className="text-left px-4 py-3">Store</th><th className="text-left px-4 py-3">Product</th><th className="text-left px-4 py-3">Action</th><th className="text-right px-4 py-3">Change</th><th className="text-right px-4 py-3">After</th><th className="text-left px-4 py-3">User</th><th className="text-left px-4 py-3">Note</th></tr>
            </thead>
            <tbody className="divide-y divide-border">
              {txns.map(t => (
                <tr key={t.id} className="hover:bg-secondary/40">
                  <td className="px-4 py-3 font-mono text-xs whitespace-nowrap">{new Date(t.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3">{t.store_name}</td>
                  <td className="px-4 py-3 font-medium">{t.product_name}</td>
                  <td className="px-4 py-3 text-muted-foreground">{t.action_type}</td>
                  <td className={`px-4 py-3 text-right font-mono ${colorFor(t.quantity_change)}`}>{t.quantity_change > 0 ? "+" : ""}{t.quantity_change}</td>
                  <td className="px-4 py-3 text-right font-mono">{t.quantity_after}</td>
                  <td className="px-4 py-3 text-muted-foreground">{t.user_name}</td>
                  <td className="px-4 py-3 text-muted-foreground truncate max-w-[200px]">{t.note}</td>
                </tr>
              ))}
              {txns.length === 0 && <tr><td colSpan={8} className="text-center py-12 text-muted-foreground">No history yet</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
